import { create } from 'zustand';

const defaultTheme = {
  id: 'default-goldbraun',
  name: 'Goldbraun Elegant (Standard)',
  isActive: true,
  colors: {
    primary: '#C4A084',
    secondary: '#B89968',
    tertiary: '#A88B5E',
    background: '#D4C4B0',
    buttonText: '#FFFFFF',
    footerBg: '#C4A084'
  }
};

const defaultBranding = {
  shopName: 'Homeyoursoul',
  tagline: 'Dein Onlineshop für Dekoration, Schmuck und Accessoires',
  logo: 'https://customer-assets.emergentagent.com/job_mobileuidebug/artifacts/6p7hdgc6_IMG_0063.png',
  favicon: ''
};

const useThemeStore = create((set) => ({
  // Active theme
  activeTheme: defaultTheme,
  
  // Branding
  branding: defaultBranding,
  
  // Layout
  layout: 'default',
  
  // Initialize theme from localStorage
  initializeTheme: () => {
    try {
      // Load active theme
      const savedThemes = localStorage.getItem('color-themes');
      if (savedThemes) {
        const themes = JSON.parse(savedThemes);
        const active = themes.find(t => t.isActive);
        if (active) {
          set({ activeTheme: active });
        }
      }
      
      // Load branding
      const savedBranding = localStorage.getItem('shop-branding');
      if (savedBranding) {
        set({ branding: JSON.parse(savedBranding) });
      }
      
      // Load layout
      const savedLayout = localStorage.getItem('page-layout');
      if (savedLayout) {
        set({ layout: savedLayout });
      }
    } catch (error) {
      console.error('Error loading theme:', error);
    }
  },
  
  // Update active theme
  setActiveTheme: (theme) => {
    set({ activeTheme: theme });
    
    // Apply CSS variables
    if (typeof document !== 'undefined') {
      const root = document.documentElement;
      root.style.setProperty('--theme-primary', theme.colors.primary);
      root.style.setProperty('--theme-secondary', theme.colors.secondary);
      root.style.setProperty('--theme-tertiary', theme.colors.tertiary || theme.colors.secondary);
      root.style.setProperty('--theme-background', theme.colors.background);
      root.style.setProperty('--theme-footer-bg', theme.colors.footerBg || theme.colors.primary);
      root.style.setProperty('--theme-button-text', theme.colors.buttonText || '#FFFFFF');
      
      // Seasonal accent colors
      if (theme.colors.accent) {
        root.style.setProperty('--theme-accent', theme.colors.accent);
      }
      if (theme.colors.accentSecondary) {
        root.style.setProperty('--theme-accent-secondary', theme.colors.accentSecondary);
      }
    }
  },
  
  // Update branding
  setBranding: (branding) => {
    set({ branding });
  },
  
  // Update layout
  setLayout: (layout) => {
    set({ layout });
  },
}));

export default useThemeStore;
